import "@/App.css";
import MirakSplash from "@/components/MirakSplash";

function App() {
  return <MirakSplash />;
}

export default App;
